import React, { useState } from "react";

import {
  Box,
  ButtonDays,
  ButtonStyledTb,
  HeadingStyled,
  LabelStyled,
} from "../../../components/styled/Elements";
import { StepsWrapper } from "./Styled";
import { Col, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import CustomRadioButton from "../../../components/common/radioButtons/CustomRadio";
import { useTranslation } from "react-i18next";
import { TimeListFrom, TimeListTo } from "../../../helpers/dummyConstants";
import { SelectionDropdown } from "../../../components/styled/FormElements";
import PhoneInputField from "../../../components/common/inputFields/PhoneInput";
import { useForm } from "react-hook-form";
import { emailRegex } from "../../../utils";

export const Step3 = ({ register, control, errors }) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState(1);
  // State to track active/inactive days
  const [selectedDays, setSelectedDays] = useState([]);

  // Array of days
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // Function to toggle day selection
  const toggleDay = (day) => {
    setSelectedDays(
      (prevSelectedDays) =>
        prevSelectedDays.includes(day)
          ? prevSelectedDays.filter((d) => d !== day) // Remove if already selected
          : [...prevSelectedDays, day] // Add if not selected
    );
  };
  const handleChange = (e) => {
    const { value } = e.target;
    setSelectedOption(parseInt(value));
  };
  return (
    <>
      <StepsWrapper>
        <HeadingStyled className="stepsMainTitle" size="24px">
          {t("ContactDetails")}
        </HeadingStyled>
        <Box className="stepFormContainer">
          <Row className="mt-3">
            <Col md={6}>
              <PhoneInputField
                name="contact_phone"
                label={"cell_phone"}
                placeholder="cell_phone"
                register={register}
                control={control}
                staric={"staric"}
                validationRules={{
                  required: true,
                }}
                className={"flex-wrap p-0"}
              />
            </Col>

            <Col md={6}>
              <PhoneInputField
                name="contact_office_phone"
                label="OfficePhone"
                placeholder="OfficePhone"
                register={register}
                control={control}
                validationRules={{
                  required: false,
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="contact_email"
                type="input"
                fieldType="text"
                placeholder="Email"
                label="Email"
                className=""
                staric={"staric"}
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                  pattern: {
                    value: emailRegex,
                    message: "invalidEmail",
                  },
                }}
                // onChange={(e) => {
                // 	e.target.value = e.target.value.replace(/\s/g, "");
                // }}
              />
            </Col>
          </Row>
        </Box>
      </StepsWrapper>
    </>
  );
};
